export default {
  CN: ['zh-cn'],
  HK: ['zh-hk', 'en-hk'],
  SG: ['en-sg'],
  TW: ['zh-tw'],
  VN: ['vi-vn'],
}
